import { Injectable } from "@nestjs/common";
import { LocationDTO } from "./location-dto";
import { Location } from "./loction-entity";
import { LocationDto, LocationsDto } from "@gtpl/shared-models/masters";


@Injectable()
export class LocationAdapater { 
    public convertDtotoEntity(LocationDTO: LocationDTO) : Location {
       
        const location = new Location();
        location.locationId = LocationDTO.locationId;
        location.locationName = LocationDTO.locationName;
        location.plant = LocationDTO.plant;
        location.isActive = LocationDTO.isActive == undefined ? true : LocationDTO.isActive;
        return location;
    }


    public convertEntitytoDto(Location : Location) : LocationDTO {
        const locationsDTO = new LocationDTO;

        locationsDTO.locationId = Location.locationId;
        locationsDTO.locationName = Location.locationName;
        locationsDTO.plant = Location.plant;
        locationsDTO.isActive = Location.isActive;
        locationsDTO.versionFlag = Location.versionFlag

        return locationsDTO;
    }
   

}
